export * from '@primeuix/themes/nora/dataview';
export { default } from '@primeuix/themes/nora/dataview';
